<template>
  <v-container class="pa-0">
    <base-subheading>Education</base-subheading>

    <v-row
      v-for="(item, i) in items"
      :key="i"
      align="center"
      class="mb-2"
    >
      <v-col
        class="d-flex"
        cols="12"
      >
        <v-img
          :src="require(`@/assets/logo/${item.avatar}`)"
          class="mr-3"
          height="48"
          max-width="48"
        />

        <div>
          <div class="subheading">
            <span class="text-h6">{{ item.title }}</span>
            <span>&ensp;&middot;&ensp;</span>
            <span class="text-subtitle-1">{{ item.aff }}</span>
          </div>

          <div class="text-subtitle-2">
            {{ item.time }}
          </div>

          <div class="text-body-1">
            {{ item.desc }}
          </div>
        </div>
      </v-col>
    </v-row>

    <base-subheading>Awards</base-subheading>

    <v-row
      align="center"
      class="mb-2"
    >
      <v-col
        class="d-flex"
        cols="12"
      >
        <div class="subheading">
          <ul>
            <li
              v-for="(award, i) in awards"
              :key="i"
            >
              <span class="text-h6">{{ award.title }}</span>
              <span>&ensp;&middot;&ensp;</span>
              <span class="text-subtitle-1">{{ award.aff }}</span>
              <span>&ensp;&middot;&ensp;</span>
              <span class="text-subtitle-1">{{ award.time }}</span>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { mapState } from 'vuex'

  export default {
    name: 'Education',

    data: () => ({
      items: [
        {
          title: 'Doctor of Philosophy',
          avatar: 'unimelb.png',
          time: '2020 - Current',
          aff: 'The University of Melbourne',
          desc: 'Thesis: Seamless high-precision vehicle positioning using GNSS-Lidar integration',
        },
        {
          title: 'Master of Engineering',
          avatar: 'unimelb.png',
          time: '2018 - 2019',
          aff: 'The University of Melbourne',
          desc: 'Spatial Engineering',
        },
        {
          title: 'Bachelor of Science',
          avatar: 'unimelb.png',
          time: '2015 - 2017',
          aff: 'The University of Melbourne',
          desc: 'Spatial Systems',
        },
      ],
      awards: [
        {
          title: 'Student Paper Award',
          time: '2022',
          aff: 'ION GNSS+ 2022 (Institute of Navigation)',
        },
        {
          title: 'Melbourne Research Scholarship',
          time: '2020 - 2023',
          aff: 'The University of Melbourne',
        },
        {
          title: 'Melbourne Global Scholar Award',
          time: '2016',
          aff: 'The University of Melbourne',
        },
      ],
    }),

    computed: {
      ...mapState(['articles']),
    },
  }
</script>
